import { render } from "./ProductReviewModal.vue?vue&type=template&id=78a65c5d&scoped=true&ts=true"
import script from "./ProductReviewModal.vue?vue&type=script&lang=ts"
export * from "./ProductReviewModal.vue?vue&type=script&lang=ts"

import "./ProductReviewModal.vue?vue&type=style&index=0&id=78a65c5d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a65c5d"]])

export default __exports__